module.exports = __webpack_public_path__ + "static/research-3df0e6d95e54c640ad81c79e8f96a60b.svg";